module.exports = __webpack_public_path__ + "img/theme2.c1cf38f9.png";